/**
 * @ngdoc service
 * @name proximus.core.headers.service:MobilePlatformService
 * @description
 * # MobilePlatformService
 *  provides mobile platform specific implementations
 */
export default class MobilePlatformService {
    constructor(configurationService) {
        this.configurationService = configurationService;
        this._configurationService = this.configurationService;
    }
    getXCallerChainHeader() {
        return 'mobileapp:' + this._configurationService.getApplicationName();
    }
}
